var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUploadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.9938 20.9203L41.9844 20.8828L36.725 7.51877C36.4907 6.76409 35.7922 6.24377 35 6.24377H13.6813C12.8844 6.24377 12.1766 6.77346 11.9516 7.53752L7.03441 20.7656L7.02035 20.7985L7.01097 20.836C6.95003 21.0656 6.93128 21.3 6.9641 21.5297C6.95941 21.6047 6.95472 21.6797 6.95472 21.7547V38.9063C6.95596 39.6618 7.25663 40.3859 7.79084 40.9202C8.32505 41.4544 9.04924 41.755 9.80472 41.7563H39.2047C40.775 41.7563 42.0547 40.4766 42.0594 38.9063V21.7547C42.0594 21.6938 42.0594 21.6328 42.0547 21.5813C42.0735 21.3516 42.0547 21.1313 41.9938 20.9203ZM28.1282 18.9047L28.1141 19.6406C28.0766 21.7453 26.6235 23.161 24.5 23.161C23.4641 23.161 22.5735 22.8281 21.9313 22.1953C21.2891 21.5625 20.9375 20.6813 20.9188 19.6406L20.9047 18.9047H11.2578L14.9844 9.84377H33.6969L37.5266 18.9047H28.1282ZM10.55 22.5047H17.9235C19.0625 25.1813 21.486 26.761 24.5047 26.761C26.0844 26.761 27.5516 26.3203 28.7375 25.486C29.7782 24.7547 30.5891 23.7328 31.1141 22.5047H38.45V38.1563H10.55V22.5047Z",
    fill: "#605BFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadIcon);
export default __webpack_public_path__ + "static/media/UploadIcon.053c5e3fc1689beacba0e3b8698b7cd3.svg";
export { ForwardRef as ReactComponent };